// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_iMK","cls2":"ResearchInterestsCard-cls2_iI- ResearchInterestsCard-cls1_iMK"};